import SelectDropdown from '@/components/component/Reuse/SelectDropdown/SelectDropdown.vue'
import InfiniteLoading from 'vue-infinite-loading';
import { getMetaCollectionList, getMetaDossierList, getReportingGroups, isUrlReachable } from '@/libs/api/api'
import {loader, urlValidation} from '@/libs/helper'
import {isEmpty} from 'lodash'

export default {
    components: {
        SelectDropdown,
        InfiniteLoading
    },
    props: {
        details: {
            type: Object,
            default: () => {}
        },
    },
    watch: {
        details (value) {
            if(value) {
            this.optionsOrganisation[0].name =  `${this.details.type ? this.details.screen_name: this.details.name} > overview`
            }
        }
    },
    data() {
        return {
            radio: 'INTERNAL',
            redirectionPrimary: 'INTERNAL',
            redirectionBackup: 'INTERNAL',
            optionsOrganisation:[
                {
                    name: `${this.details.type ? this.details.screen_name: this.details.name} > overview`,
                    id: 'Option1'
                }, 
                // {
                //     name: 'Organisation > About',
                //     id: 'Option2'
                // }
            ],
            collectionList: [],
            dossierList: [],
            optionsReportingGroup: [{
                label: 'Accura Newsroom announced',
                value: 'Option1'
            }, {
                label: 'Facebook campaign Sept 2020',
                value: 'Option2'
            }, {
                label: 'Short URL Press release Dec 2020',
                value: 'Option3'
            }
            ],
            valueInternal: {},
            valueInternalBackup: {},
            isPrimaryExternalUrlVerified: false,
            isBackupExternalUrlVerified: false,
            valueReportingGroup: '',
            valueDomain: 'Options1',
            valueExternal: '',
            valueExternalBackup: '',
            page: 1,
            skip: 0,
            limit: 10,
            dossierSkip: 0,
            isFetchingCollections: false,
            isLoadMore: true,
            isFetchingDossiers: false,
            isLoadMoreDossiers: true,
            urlPopover: false,
            reportingGroups: []
        }
    },
    mounted() {
        this.fetchCollections(true)
        this.fetchDossiers(true)
        this.fetchreportingGroups()
    },
    computed: {
        pageHeading() {
            switch(this.page){
                case 2: return 'Set the back-up URL for this short URL'
                case 3: return 'Set URL Reporting group'
                default: return 'Do you want to add an internal or external URL?'
            }
        },
        isDisabledCollections () {
            return !this.isLoadMore || this.isFetchingCollections
        },
        isDisabledDossiers () {
            return !this.isLoadMoreDossiers || this.isFetchingDossiers
        }
    },
    methods: {
        fetchCollections (isLoadMore) {
            this.isFetchingCollections = true
            // paarams for api
            let params = {
                skip: this.skip,
                limit: this.limit
            }
            // body for api
            let body = {
                entity_type: this.details.type || 'ORGANISATION',
                entity_id: this.details._id || this.details.id
            }
            // api call
            getMetaCollectionList(body, params)
            .then(response => {
                // if loading more than concat the list
                if (isLoadMore) this.collectionList = this.collectionList.concat(response.items || [])
                // initialise the list
                else this.collectionList = response.items || []
                // increase the skip
                this.skip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMore = false
                }
                // to make fetching false
                this.isFetchingCollections = false
            })
            .catch(() => {
                this.isLoadMore = true
                this.isFetchingCollections = false
                this.skip = 0
            })
        },

        async fetchDossiers (isLoadMore) {
            try {
                this.isFetchingDossiers = true
                // params for api
                let params = {
                    skip: this.dossierSkip,
                    limit: this.limit
                }
                // body for api
                let body = {
                    entity_type: this.details.type || 'ORGANISATION',
                    entity_id: this.details._id || this.details.id
                }
                // api call
                let response = await getMetaDossierList(body, params)
                // if loading more than concat the list
                if (isLoadMore) this.dossierList = this.dossierList.concat(response.items || [])
                // initialise the list
                else {
                    this.dossierList = response.items || []
                    // this.selectedCollection = (response.items && response.items[0]) || {}
                }
                // increase the skip
                this.dossierSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreDossiers = false
                }
            } catch (error) {
                this.isLoadMoreDossiers = false
            }
            // to make fetching false
            this.isFetchingDossiers = false
        },

        /**
         * infinite loading handler collection
         */
         handleCollectionInfiniteLoading () {
            if (!this.isFetchingCollections && this.isLoadMore) this.fetchCollections(true)
        },

        /**
         * infinite loading handler dossier
         */
        handleDossierInfiniteLoading () {
            if (!this.isFetchingDossiers && this.isLoadMoreDossiers) this.fetchDossiers(true)
        },

        setInternalValue(selectedValue,type) {
            if(!selectedValue)
                return;

            if(this.page===1){
                this.valueInternal = selectedValue;
                this.valueInternal['type'] = type;
            } else {
                this.valueInternalBackup = selectedValue            
                this.valueInternalBackup['type'] = type;
            }
        },

        addUrl() {
            const payload = {
                valuesPrimary:{
                    valueInternal: this.valueInternal,
                    valueExternal: this.valueExternal,
                    redirection_type: this.redirectionPrimary,
                },
                valuesBackup: {
                    valueInternalBackup: this.valueInternalBackup,
                    valueExternalBackup: this.valueExternalBackup,
                    redirection_type: this.redirectionBackup,
                },
                valueReportingGroup: this.valueReportingGroup,
            }

            this.$emit('addShortUrl',payload);
        },

        setRedirection() {
            this.page===1 ? this.redirectionPrimary = this.radio : this.redirectionBackup = this.radio
        },
        nextPage() {
            if (this.radio) {
                this.page++;
                this.radio = 'INTERNAL'
            }
        },
        /**
         * to fetch reporting groups
         */
         fetchreportingGroups () {
            if (!this.details._id && !this.details.id) return
            // body for api
            let body = {
                entity_type: this.details.type || 'ORGANISATION',
                entity_id: this.details._id || this.details.id
            }
            // api call
            getReportingGroups(body)
            .then(response => {
                this.reportingGroups = response.result || []
            }).catch(error => {
                console.error(error)
            })
        },

        /**
         * test domain
         */
        async testDomain () {
            try {
                loader(this, true)
                let body = {
                    url: this.valueExternal
                }
                
                if (this.page === 2) body.url = this.valueExternalBackup
                
                let response = await isUrlReachable(body)
                if (this.page === 2) this.isBackupExternalUrlVerified = response.is_reachable
                else this.isPrimaryExternalUrlVerified = response.is_reachable
            } catch (error) {
                console.warn(error)
            }
            finally {
                loader(this, false)
            }
        },

        /**
         * disable test button
         * @returns is-disabled true/false
         */
        disabledTestButton () {
            if (this.page=== 2 && (this.redirectionBackup !== 'EXTERNAL' || this.valueExternalBackup === '' || !urlValidation(this.valueExternalBackup))) return true

            if (this.page == 1 && (this.redirectionPrimary !== 'EXTERNAL' || this. valueExternal === '' || !urlValidation(this.valueExternal))) return true

            return false
        },

        /**
         * disable next button
         * @returns is-disabled true/false
         */
        disabledNextButton () {
            const page = this.page
            if (page === 1 && ((this.redirectionPrimary === 'INTERNAL' && isEmpty(this.valueInternal)) || 
            (
                this.redirectionPrimary === 'EXTERNAL' && (this.valueExternal === '' || !urlValidation(this.valueExternal) || !this.isPrimaryExternalUrlVerified)))) {
                    return true
            } 
            if (page === 2 && ((this.redirectionBackup === 'INTERNAL' && isEmpty(this.valueInternalBackup)) || 
                (
                this.redirectionBackup === 'EXTERNAL' && (this.valueExternalBackup === '' || !urlValidation(this.valueExternalBackup) || !this.isBackupExternalUrlVerified)))) {
                    return true
            } 
                return false
        }
    }
}